<template>
  <div class="tag">
    <el-tag v-for="(tag, index) in tags" :key="tag.path" closable type="info" :class="{ 'tag-active': isActive(tag) }"
      @click="handleTagClick(tag)" @close="handleTagClose(tag, index)">
      {{ tag.name }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: "NavTags",
  data() {
    return {
      tags: [],
      activePath: "",
    };
  },
  mounted() {
    this.loadTagsFromStorage();
    this.initTagsWithCurrentRoute();
  },
  methods: {
    // 从本地存储加载标签页数据
    loadTagsFromStorage() {
      try {
        const savedTags = localStorage.getItem('navTags');
        if (savedTags) {
          this.tags = JSON.parse(savedTags);
        }
      } catch (error) {
        console.warn('加载标签页数据失败:', error);
        this.tags = [];
      }
    },
    // 保存标签页数据到本地存储
    saveTagsToStorage() {
      try {
        localStorage.setItem('navTags', JSON.stringify(this.tags));
      } catch (error) {
        console.warn('保存标签页数据失败:', error);
      }
    },
    initTagsWithCurrentRoute() {
      this.activePath = this.$route.fullPath;
      this.addTagFromRoute(this.$route);
    },
    addTagFromRoute(route) {
      let name = (route.meta && route.meta.title) || route.name || route.path;
      let path = route.fullPath;
      if (path.includes('/activity/managementEdit?id=')) {
        name = '编辑活动'
      }
      if (path.includes('/activity/addClass?id=')) {
        name = '编辑班级'
      }
      if (!this.tags.some((t) => t.path === path)) {
        this.tags.push({ name, path });
        this.saveTagsToStorage();
      }
    },
    isActive(tag) {
      return tag.path === this.activePath;
    },
    handleTagClick(tag) {
      if (tag.path !== this.activePath) {
        this.$router.push(tag.path);
      }
    },
    handleTagClose(tag, index) {
      const isClosingActive = tag.path === this.activePath;
      this.tags.splice(index, 1);
      this.saveTagsToStorage(); // 保存到本地存储

      if (!isClosingActive) return;

      if (this.tags.length === 0) {
        this.safeGoHome();
        return;
      }

      // 优先跳到右侧标签，否则左侧
      const next = this.tags[index] || this.tags[index - 1] || this.tags[0];
      if (next) {
        this.$router.push(next.path);
      } else {
        this.safeGoHome();
      }
    },
    safeGoHome() {
      const home = "/activity/management";
      if (this.activePath !== home) {
        this.$router.push(home);
      }
    },
  },
  watch: {
    $route(to) {
      console.log(to)
      this.activePath = to.fullPath;
      this.addTagFromRoute(to);
    },
    tags: {
      handler(newVal, oldVal) {
        if (newVal.length > 15) {
          let tagArr = JSON.parse(JSON.stringify(newVal))
          tagArr.shift()
          this.tags = tagArr
        }
      },
      deep: true
    }
  },
};
</script>

<style lang="scss">
.tag {
  margin-bottom: 10px;
  cursor: pointer;

  .el-tag.el-tag--info {
    background: #f3f3f3;
    color: rgba(0, 0, 0, 0.9);
    margin-right: 10px;
  }

  .el-tag.el-tag--info .el-tag__close {
    color: rgba(0, 0, 0, 0.4);
  }

  .el-tag.el-tag--info:hover {
    background: #c12e30;
    color: #fff;

    .el-tag__close {
      background-color: transparent;
      color: #fff;
    }
  }

  .el-tag.tag-active {
    background: #c12e30;
    color: #fff;

    .el-tag__close {
      background-color: transparent;
      color: #fff;
    }
  }
}
</style>